/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Cancel_RoundInputs */



/**
* | output |
* | --- |
* | "Cancel Round" |
*
* @param {Rounds_Cancel_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_cancel_round = /** @type {((inputs?: Rounds_Cancel_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Cancel_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler la ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelar Rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla Round")
	return /** @type {LocalizedString} */ ("Cancel Round")
});